/* ZAMOTHRA interactions: the turn, header panels, mobile menu, reveals. */
(() => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  /* The turn: pointer position (or a swipe, or arrow keys) steps through a
     frame's own photographs. Extra frames load on first interaction. */
  if (!customElements.get('zmt-turn')) {
    class ZmtTurn extends HTMLElement {
      connectedCallback() {
        if (this._ready) return;
        this._ready = true;
        this.frames = [...this.querySelectorAll('[data-zmt-frame]')];
        this.ticks = [...this.querySelectorAll('[data-zmt-tick]')];
        this.count = this.frames.length + 1;
        this.index = 0;
        if (this.count < 2) return;
        this.setAttribute('data-zmt-ready', '');

        this.addEventListener('pointerenter', () => this.load(), { passive: true });
        this.addEventListener('focusin', () => this.load());
        this.addEventListener('pointermove', (e) => {
          if (e.pointerType === 'touch') return;
          const r = this.getBoundingClientRect();
          const p = Math.min(0.999, Math.max(0, (e.clientX - r.left) / r.width));
          this.show(Math.floor(p * this.count));
        }, { passive: true });
        if (this.hasAttribute('data-zmt-reset')) {
          this.addEventListener('pointerleave', () => this.show(0), { passive: true });
        }
        if (this.hasAttribute('data-zmt-swipe')) {
          let sx = null, sy = null, start = 0;
          this.addEventListener('touchstart', (e) => {
            const t = e.touches[0]; sx = t.clientX; sy = t.clientY; start = this.index; this.load();
          }, { passive: true });
          this.addEventListener('touchmove', (e) => {
            if (sx === null) return;
            const t = e.touches[0];
            const dx = t.clientX - sx, dy = t.clientY - sy;
            if (Math.abs(dx) < 10 || Math.abs(dx) < Math.abs(dy)) return;
            const step = Math.round(-dx / (this.clientWidth / this.count));
            this.show(Math.max(0, Math.min(this.count - 1, start + step)));
          }, { passive: true });
          this.addEventListener('touchend', () => { sx = null; }, { passive: true });
        }
        this.addEventListener('keydown', (e) => {
          if (e.key === 'ArrowRight') { e.preventDefault(); this.load(); this.show(Math.min(this.index + 1, this.count - 1)); }
          if (e.key === 'ArrowLeft') { e.preventDefault(); this.show(Math.max(this.index - 1, 0)); }
        });
      }
      load() {
        if (this._loaded) return;
        this._loaded = true;
        this.frames.forEach((img) => {
          if (img.dataset.srcset) img.srcset = img.dataset.srcset;
          if (img.dataset.src) img.src = img.dataset.src;
        });
      }
      show(i) {
        if (i === this.index) return;
        this.index = i;
        this.frames.forEach((f, k) => f.classList.toggle('is-on', k + 1 === i));
        this.ticks.forEach((t, k) => t.classList.toggle('is-on', k === i));
        const status = this.querySelector('[data-zmt-turn-status]');
        if (status) status.textContent = `View ${i + 1} of ${this.count}`;
      }
    }
    customElements.define('zmt-turn', ZmtTurn);
  }

  /* Frames panel: one open at a time, closes on Escape or outside click. */
  document.addEventListener('click', (e) => {
    document.querySelectorAll('details[data-zmt-frames][open]').forEach((d) => {
      if (!d.contains(e.target)) d.removeAttribute('open');
    });
  });
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    document.querySelectorAll('details[data-zmt-frames][open]').forEach((d) => {
      d.removeAttribute('open');
      const s = d.querySelector('summary');
      if (s) s.focus();
    });
  });

  /* Mobile menu: a native dialog, so focus is trapped and Escape closes it. */
  const menu = document.getElementById('ZmtMenu');
  document.querySelectorAll('[data-zmt-menu-open]').forEach((btn) => {
    btn.addEventListener('click', () => {
      if (!menu) return;
      menu.showModal();
      btn.setAttribute('aria-expanded', 'true');
    });
  });
  if (menu) {
    menu.addEventListener('close', () => {
      document.querySelectorAll('[data-zmt-menu-open]').forEach((b) => b.setAttribute('aria-expanded', 'false'));
    });
    menu.addEventListener('click', (e) => { if (e.target === menu) menu.close(); });
    menu.querySelectorAll('[data-zmt-menu-close]').forEach((b) => b.addEventListener('click', () => menu.close()));
  }

  /* Reveals: only for headings and editorial blocks, never product information. */
  const reveal = document.querySelectorAll('[data-zmt-reveal]');
  if (reveal.length && 'IntersectionObserver' in window && !reduceMotion.matches) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach((en) => {
        if (en.isIntersecting) { en.target.classList.add('is-revealed'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    reveal.forEach((el) => io.observe(el));
    setTimeout(() => reveal.forEach((el) => el.classList.add('is-revealed')), 3000);
  } else {
    reveal.forEach((el) => el.classList.add('is-revealed'));
  }
})();

/* Policy pages are written in Shopify admin as plain paragraphs. Give them the same
   structure as the rest of the site: drop empty paragraphs, turn "Label: text" and
   short ALL-CAPS lines into headings. The policy text itself is not changed. */
(function () {
  var body = document.querySelector('.shopify-policy__body .rte, .shopify-policy__body');
  if (!body) return;
  Array.prototype.forEach.call(body.querySelectorAll('p'), function (p) {
    var text = p.textContent.replace(/\u00a0/g, ' ').trim();
    if (!text && !p.querySelector('img, iframe')) { p.remove(); return; }
    if (p.querySelector('strong, b, h2, h3')) return;
    if (text.length <= 60 && text === text.toUpperCase() && /[A-Z]/.test(text)) { p.innerHTML = '<span class="zmt-pol-h">' + p.innerHTML + '</span>'; return; }
    var m = p.innerHTML.match(/^\s*([A-Z][A-Za-z&'’ /-]{2,40}):\s*/);
    if (m) p.innerHTML = '<span class="zmt-pol-h">' + m[1] + '</span>' + p.innerHTML.slice(m[0].length);
  });
})();
